import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <NFLTemplate
    {...props}
    team="Arizona Cardinals"
    teamShort="Cardinals"
    teamId={teamIds['Arizona Cardinals']}
  />
)
